import { initErrorTracking } from "@lib/errorTracking";
import { graphqlClient } from "@lib/graphql/client";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { Provider } from "urql";
import { App } from "@/App";

const rootEl = document.getElementById("talent-app-root");
if (rootEl) {
  const currentUser = JSON.parse(rootEl.dataset.currentUser || "null");
  const currentOrganisation = JSON.parse(rootEl.dataset.currentOrganisation || "null");
  initErrorTracking({ user_id: currentUser?.id, organisation_id: currentOrganisation?.id });
  const pendingTerms = JSON.parse(rootEl.dataset.pendingTerms || "[]");

  const impersonation =
    rootEl.dataset.impersonating === "true"
      ? {
          impersonatedUserName: rootEl.dataset.impersonatedUserName || "",
          trueUserName: rootEl.dataset.trueUserName || "",
          stopPath: rootEl.dataset.stopImpersonationPath || "",
          csrfToken: rootEl.dataset.csrfToken || "",
        }
      : null;

  createRoot(rootEl).render(
    <React.StrictMode>
      <Provider value={graphqlClient}>
        <BrowserRouter basename="/app">
          <App
            currentUser={currentUser}
            currentOrganisation={currentOrganisation}
            pendingTerms={pendingTerms}
            impersonation={impersonation}
          />
        </BrowserRouter>
      </Provider>
    </React.StrictMode>,
  );
}
